/**
 *
 * Asynchronously loads the component for Reports
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserProfile = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.UserProfile,
);
